import React from 'react';
import "./NewUI.css"
import "./Home.css"
import "./searchBoxUI.css"
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import "./spinner.css"
import Header from '../Header';
import Page from '../homePage';
import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import CarouselComponent from '../carousel/Carousel';
import PadSplitData from '../padsplit/PadSplit';
import NewPadSplit from '../padsplit/newPadsplit';
import Affordable_Hub from '../affordabe and hud/affordable_hud';
import Affordable_housing from '../affordabe and hud/affordable_housing';
import Reference_Properties from '../reference-properties/reference-properties';
import Rental_Comps from '../rental-comps/rental-comps';

class Home extends React.Component {
    constructor(props) {
        super(props)
        this.searchUrl = new URLSearchParams(window.location.search)
        this.subjectAddress = React.createRef()
        this.navigation = this.props.navigation
        this.getSinglePropertyData = this.getSinglePropertyData.bind(this)
        this.handleComProperty = this.handleComProperty.bind(this)
        this.getCompPropertyData = this.getCompPropertyData.bind(this)
        this.state = {
            referenceProps: [],
            isStored: true,
            isLiCount: 0,
            isBedHover: false,
            isReferences: false,
            isError: false,
            index: 0,
            placeholder: "Search Properties",
            isAutoComp: false,
            isHudData: false,
            isHover: false,
            basicInfo: false,
            prices: false,
            county_subdivisions: false,
            status_neighbourhood: false,
            links: false,
            isMap: false,
            isAffHouse: false,
            text: "",
            isOpen: false,
            isAddField: false,
            UUID: [],
            inputCount: 0,
            fieldCount: 0,
            loading: false,
            REISearchloading: false,
            subjectProperty: "",
            compProperty: [],
            flag: false,
            showTbl: false,
            subjectRefinedData: {},
            refinedData: {
                display_image_url: [],

                beds: [],
                baths: [],
                square_feet: [],
                lot_square_feet: [],
                year_built: [],
                story: [],
                garage_type: [],

                distance_from_subject: [],

                neighbourhood: [],
                subdivision: [],
                community: [],
                county: [],
                redfin: [],
                zillow: [],
                realtor: [],
                price: [],

                price_per_square_feet: [],
                estimated_rent: [],
                square_feet_difference: [],
                adjusted_sales_price: [],

                status: [],
                date_format: [],
                date_sold: [],

                median_price_neighborhood: [],
                median_price_macro_neighborhood: [],

                redfin_link: [],
                zillow_link: [],
                realtor_link: [],

                latitude: [],
                longitude: [],
                address: [],
                // url: [],
                reference_point: [],
                comp_score: [],
                static_map: [],
                zip: [],
            },
            affordablehousing_data: {},
            huduser_data: {},
            compAffordablehousing_data: [],
            compHuduser_data: [],
            comp_carousel_images: [],
            subject_carousel_images: [],
            city: "",
            state: "",
            zip: ""
        }

    }

    componentDidMount() {
        if (this.searchUrl.get("q")) {
            this.setState({
                text: this.searchUrl.get("q"),
                subjectProperty: this.searchUrl.get("q")
            })
            this.getAutoComps(this.searchUrl.get("q").replaceAll(", USA", ""));
        }

    }

    async getSinglePropertyData() {
        if (this.state.loading) { return }
        this.setState({
            loading: true,
            fieldCount: 1,
            REISearchloading: true
        })

        await axios.post(`${process.env.REACT_APP_BASE_URL}subject_property`, {
            "is_subject": true,
            "properties": [
                this.state.subjectProperty
            ],
            "subject_property": null
        })
            .then(async (resp) => {

                let thisProp = await Object.values(resp.data.subject_property)[0]
                let data = {
                    display_image_url: thisProp.display_image ?? thisProp.display_image_url,
                    beds: thisProp.beds ? thisProp.beds : "None",
                    baths: thisProp.baths ? thisProp.baths : "None",
                    square_feet: thisProp.square_feet ? thisProp.square_feet : "None",
                    lot_square_feet: thisProp.lot_square_feet ? thisProp.lot_square_feet : "None",
                    year_built: thisProp.year_built ? thisProp.year_built : "None",
                    story: thisProp.story ? thisProp.story : "None",
                    garage_type: thisProp.garage_type ? thisProp.garage_type : "No Garage",
                    distance_from_subject: "Subject Property",
                    neighbourhood: thisProp.neighbourhood ? thisProp.neighbourhood : "None",
                    subdivision: thisProp.subdivision ? thisProp.subdivision : "None",
                    community: thisProp.community ? thisProp.community : "None",
                    county: thisProp.county ? thisProp.county : "None",

                    zip: thisProp.zip,

                    zillow: thisProp.zillow ? this.ExportNumberFormat(thisProp.zillow) : "?",
                    realtor: thisProp.realtor ? this.ExportNumberFormat(thisProp.realtor) : "?",
                    redfin: thisProp.redfin ? this.ExportNumberFormat(thisProp.redfin.toFixed(0)) : "?",
                    price: thisProp.price ? this.ExportNumberFormat(thisProp.price) : "?",

                    price_per_square_feet: thisProp.price_per_square_feet ? this.ExportNumberFormat(thisProp.price_per_square_feet) : "?",
                    estimated_rent: thisProp.estimated_rent ? this.ExportNumberFormat(thisProp.estimated_rent) : "?",
                    square_feet_difference: thisProp.square_feet_difference ? this.ExportNumberFormat(thisProp.square_feet_difference) : "?",
                    adjusted_sales_price: thisProp.adjusted_sales_price ? this.ExportNumberFormat(thisProp.adjusted_sales_price) : "?",

                    status: thisProp.listing_status ? (thisProp.listing_status.charAt(0).toUpperCase() + thisProp.listing_status.slice(1)).replaceAll('_', " ") : "None",
                    date_format: thisProp.date_format,
                    date_sold: thisProp.date_sold ? thisProp.date_sold : "None",

                    median_price_neighborhood: thisProp.median_price?.city ? this.ExportNumberFormat(thisProp.median_price?.city) : "None",
                    median_price_macro_neighborhood: thisProp.median_price?.zip ? this.ExportNumberFormat(thisProp.median_price?.zip) : "None",

                    redfin_link: thisProp.redfin_link ? thisProp.redfin_link : "None",
                    zillow_link: thisProp.zillow_link ? thisProp.zillow_link : "None",
                    realtor_link: thisProp.realtor_link ? thisProp.realtor_link : "None",

                    latitude: thisProp.map_coordinates?.latitude ? thisProp.map_coordinates?.latitude : "None",
                    longitude: thisProp.map_coordinates?.longitude ? thisProp.map_coordinates?.longitude : "None",
                    address: thisProp.map_coordinates?.address ? thisProp.map_coordinates?.address : thisProp?.address ? thisProp?.address : "None",

                }

                if (data.address === "None") {
                    toast.error('There is no data available')
                    setTimeout(() => {
                        this.handleSubjectPropertyClose()
                    }, 3000);
                }
                let Exportdata = {
                    display_image_url: thisProp.display_image_url ? thisProp.display_image_url : "None",
                    property: "SUBJECT PROPERTY",
                    address: thisProp.address ? thisProp.address : "None",
                    beds: thisProp.beds ? thisProp.beds : "None",
                    baths: thisProp.baths ? thisProp.baths : "None",
                    square_feet: thisProp.square_feet ? thisProp.square_feet : "None",
                    lot_square_feet: thisProp.lot_square_feet ? thisProp.lot_square_feet : "None",
                    year_built: thisProp.year_built ? thisProp.year_built : "None",
                    story: thisProp.story ? thisProp.story : "None",
                    garage_type: thisProp.garage_type ? thisProp.garage_type : "No Garage",

                    distance_from_subject: thisProp.distance_from_subject ? thisProp.distance_from_subject : "Subject Property",

                    neighbourhood: thisProp.neighbourhood ? thisProp.neighbourhood : "None",
                    city: thisProp.city ? thisProp.city : "None",
                    county: thisProp.county ? thisProp.county : "None",

                    zillow: thisProp.zillow ? this.ExportNumberFormat(thisProp.zillow) : "None",
                    realtor: thisProp.realtor ? this.ExportNumberFormat(thisProp.realtor) : "None",
                    price: thisProp.price ? this.ExportNumberFormat(thisProp.price) : "None",

                    price_per_square_feet: thisProp.price_per_square_feet ? this.ExportNumberFormat(thisProp.price_per_square_feet) : "None",
                    estimated_rent: thisProp.estimated_rent ? this.ExportNumberFormat(thisProp.estimated_rent) : "None",
                    square_feet_difference: thisProp.square_feet_difference ? this.ExportNumberFormat(thisProp.square_feet_difference) : "None",
                    adjusted_sales_price: thisProp.adjusted_sales_price ? this.ExportNumberFormat(thisProp.adjusted_sales_price) : "None",

                    status: data.status ? data.status : "None",
                    date_sold: thisProp.date_sold ? thisProp.date_sold : "None",

                    median_price_neighborhood: thisProp.median_price?.city ? this.ExportNumberFormat(thisProp.median_price?.city) : "None",
                    redfin_link: thisProp.redfin_link ? thisProp.redfin_link : "None",
                    zillow_link: thisProp.zillow_link ? thisProp.zillow_link : "None",
                    realtor_link: thisProp.realtor_link ? thisProp.realtor_link : "None",
                    static_map: thisProp.static_map ? thisProp.static_map : "None",
                    left_affordablehousing_data: [thisProp.huduser_data ? thisProp.huduser_data["Two-Bedroom FMR Basis"] +
                        " " + thisProp.zip + " " + thisProp.beds + " bedrooms" : "?" + thisProp.zip + " " + thisProp.beds + " bedrooms",
                        "Affordablehousing.com",
                    thisProp.beds + " bedrooms", "county", "city", "zip",
                    thisProp.affordablehousing_data ? thisProp.affordablehousing_data['mile radius'].radius + " mile radius" : "? mile radius"],

                    right_affordablehousig_data: [thisProp.affordablehousing_data ? "$ " + thisProp.affordablehousing_data["zip"].rent_estimate
                        : "None", "Market Rent Estimation", "Affordablehousing.com",
                    thisProp.affordablehousing_data ? "$ " + thisProp.affordablehousing_data.county.rent_estimate : "None",
                    thisProp.affordablehousing_data ? "$ " + thisProp.affordablehousing_data["city"].rent_estimate : "None",
                    thisProp.affordablehousing_data ? "$ " + thisProp.affordablehousing_data["zip"].rent_estimate : "None",
                    thisProp.affordablehousing_data ? "$ " + thisProp.affordablehousing_data['mile radius'].rent_estimate : "None"],

                    left_huduser_data: ["Efficiency", "One-Bedroom", "Two-Bedroom", "Three-Bedroom", "Four-Bedroom", "Two-Bedroom FMR Basis"],

                    right_huduser_data: [thisProp.huduser_data["Efficiency"] ? thisProp.huduser_data["Efficiency"] : "None",
                    thisProp.huduser_data["One-Bedroom"] ? thisProp.huduser_data["One-Bedroom"] : "None",
                    thisProp.huduser_data["Two-Bedroom"] ? thisProp.huduser_data["Two-Bedroom"] : "None",
                    thisProp.huduser_data["Three-Bedroom"] ? thisProp.huduser_data["Three-Bedroom"] : "None",
                    thisProp.huduser_data["Four-Bedroom"] ? thisProp.huduser_data["Four-Bedroom"] : "None",
                    thisProp.huduser_data["Two-Bedroom FMR Basis"] ? thisProp.huduser_data["Two-Bedroom FMR Basis"] : "None"]
                }


                this.setState({
                    subjectRefinedData: data,
                    isAddField: true,
                    text: "",
                    affordablehousing_data: thisProp.affordablehousing_data ? thisProp.affordablehousing_data : "None",
                    huduser_data: thisProp.huduser_data ? thisProp.huduser_data : "None"
                })
                if (data.address !== "None") {
                    setTimeout(async () => {
                        try {
                            await axios.post(`${process.env.REACT_APP_BASE_URL}store_data`,
                                JSON.stringify(Exportdata)
                            )
                                .then(async (res) => {
                                    let stateObj = { id: "100" };
                                    window.history.replaceState(stateObj,
                                        "null", (this.state.subjectRefinedData.address).replaceAll(" ", "-"));
                                    // console.log("res", res)
                                    this.setState({
                                        REISearchloading: false,
                                        loading: false,
                                        showTbl: true,
                                        text: "",
                                        placeholder: "Manually Add a Comp"
                                    })
                                    this.state.UUID.push(res.data)
                                }).then(async () => console.log('uuid', this.state.UUID))
                        } catch (e) {
                            toast.error("Failed to store the data")
                            this.setState({
                                REISearchloading: false,
                                loading: false,
                                showTbl: true,
                                text: ""
                            })
                        }

                    }, 1000);
                }

            })
            .catch((error) => {
                toast.error("something went wrong!")
                this.setState({
                    REISearchloading: false,
                    loading: false,
                    text: "",
                    fieldCount: 0
                })
            })
    };
    async getAutoComps(subjectProperty) {
        if (this.state.loading) { return }
        this.setState({
            loading: true,
            fieldCount: 1,
            REISearchloading: true
        })
        const body = {
            "is_subject": true,
            "properties": [
                subjectProperty.replaceAll(/[\n\r\t\s]+/g, ' ')
            ],
            "auto_comp": "True"
        }
        const headers = {
            headers: {
                Authorization: "Bearer " + sessionStorage.getItem("token")
            }
        }
        await axios.post(`${process.env.REACT_APP_BASE_URL}auto_comp`, body, headers).then(async (resp) => {
            let thisProp = await Object.values(resp.data.subject_property)[0]
            let compProp = await Object.values(resp.data.comp_properties)
            let subjectData = {
                display_image_url: thisProp.display_image ?? thisProp.display_image_url,
                // display_image_url: thisProp.display_image_url ? thisProp.display_image-url : "None",

                beds: thisProp.beds ? thisProp.beds : "None",
                baths: thisProp.baths ? thisProp.baths : "None",
                square_feet: thisProp.square_feet ? thisProp.square_feet : "None",
                lot_square_feet: thisProp.lot_square_feet ? thisProp.lot_square_feet : "None",
                year_built: thisProp.year_built ? thisProp.year_built : "None",
                story: thisProp.story ? thisProp.story : "None",
                garage_type: thisProp.garage_type ? thisProp.garage_type : "No Garage",
                distance_from_subject: "Subject Property",
                neighbourhood: thisProp.neighbourhood ? thisProp.neighbourhood : "None",
                subdivision: thisProp.subdivision ? thisProp.subdivision : "None",
                community: thisProp.community ? thisProp.community : "None",
                county: thisProp.county ? thisProp.county : "None",

                zip: thisProp.zip,

                zillow: thisProp.zillow ? this.ExportNumberFormat(thisProp.zillow) : "?",
                realtor: thisProp.realtor ? this.ExportNumberFormat(thisProp.realtor) : "?",
                redfin: thisProp.redfin ? this.ExportNumberFormat(thisProp.redfin.toFixed(0)) : "?",
                price: thisProp.price ? this.ExportNumberFormat(thisProp.price) : "?",

                price_per_square_feet: thisProp.price_per_square_feet ? this.ExportNumberFormat(thisProp.price_per_square_feet) : "?",
                estimated_rent: thisProp.estimated_rent ? this.ExportNumberFormat(thisProp.estimated_rent) : "?",
                square_feet_difference: "Subject property",
                adjusted_sales_price: thisProp.adjusted_sales_price ? this.ExportNumberFormat(thisProp.adjusted_sales_price) : "?",

                status: thisProp.listing_status ? (thisProp.listing_status.charAt(0).toUpperCase() + thisProp.listing_status.slice(1)).replaceAll('_', " ") : "None",
                date_format: thisProp.date_format,
                date_sold: thisProp.date_sold ? thisProp.date_sold : "None",

                median_price_neighborhood: thisProp.median_price?.neighborhood ? this.ExportNumberFormat(thisProp.median_price?.neighborhood) : "None",
                median_price_macro_neighborhood: thisProp.median_price?.macro_neighborhood ? this.ExportNumberFormat(thisProp.median_price?.macro_neighborhood) : "None",

                redfin_link: thisProp.redfin_link ? thisProp.redfin_link : "None",
                zillow_link: thisProp.zillow_link ? thisProp.zillow_link : "None",
                realtor_link: thisProp.realtor_link ? thisProp.realtor_link : "None",

                latitude: thisProp.map_coordinates?.latitude ? thisProp.map_coordinates?.latitude : "None",
                longitude: thisProp.map_coordinates?.longitude ? thisProp.map_coordinates?.longitude : "None",
                address: thisProp.map_coordinates ? thisProp.map_coordinates.address : thisProp.address ? thisProp.address : "None",
                reference_point: thisProp.reference_point ? thisProp.reference_point : "None",
                comp_score: thisProp.comp_score ? thisProp.comp_score.toFixed(2) : "None",

                // url: thisProp.url
            }
            if (subjectData.address === "None") {
                this.setState({
                    loading: false
                })
                toast.error("There is no data available on " + subjectProperty.replaceAll(/[\n\r\t\s]+/g, ' '))
                setTimeout(() => {
                    this.handleSubjectPropertyClose()
                }, 5000);

            } else {
                this.setState({
                    affordablehousing_data: thisProp.affordablehousing_data ? thisProp.affordablehousing_data : "None",
                    huduser_data: thisProp.huduser_data ? thisProp.huduser_data : "None",
                    subject_carousel_images: thisProp.carousel_images,
                    city: thisProp.city,
                    state: thisProp.state,
                    zip: thisProp.zip
                })
                let duplicateExport = []
                let ExportSubjectdata = {
                    display_image_url: thisProp.display_image ? thisProp.display_image : "None",
                    property: "SUBJECT PROPERTY",
                    address: thisProp.address ? thisProp.address : "None",
                    beds: thisProp.beds ? thisProp.beds : "None",
                    baths: thisProp.baths ? thisProp.baths : "None",
                    square_feet: thisProp.square_feet ? thisProp.square_feet : "None",
                    lot_square_feet: thisProp.lot_square_feet ? thisProp.lot_square_feet : "None",
                    year_built: thisProp.year_built ? thisProp.year_built : "None",
                    story: thisProp.story ? thisProp.story : "None",
                    garage_type: thisProp.garage_type ? thisProp.garage_type : "No Garage",

                    distance_from_subject: thisProp.distance_from_subject ? thisProp.distance_from_subject : "Subject Property",
                    neighbourhood: thisProp.neighbourhood ? thisProp.neighbourhood : "None",
                    city: thisProp.city ? thisProp.city : "None",
                    county: thisProp.county ? thisProp.county : "None",
                    zillow: thisProp.zillow ? this.ExportNumberFormat(thisProp.zillow) : "None",
                    realtor: thisProp.realtor ? this.ExportNumberFormat(thisProp.realtor) : "None",
                    price: thisProp.price ? this.ExportNumberFormat(thisProp.price) : "None",
                    price_per_square_feet: thisProp.price_per_square_feet ? this.ExportNumberFormat(thisProp.price_per_square_feet) : "None",
                    estimated_rent: thisProp.estimated_rent ? this.ExportNumberFormat(thisProp.estimated_rent) : "None",
                    square_feet_difference: thisProp.square_feet_difference ? this.ExportNumberFormat(thisProp.square_feet_difference) : "None",
                    adjusted_sales_price: thisProp.adjusted_sales_price ? this.ExportNumberFormat(thisProp.adjusted_sales_price) : "None",

                    status: subjectData.status ? subjectData.status : "None",
                    date_sold: thisProp.date_sold ? thisProp.date_sold : "None",

                    median_price_neighborhood: thisProp.median_price?.city ? this.ExportNumberFormat(thisProp.median_price?.city) : "None",
                    redfin_link: thisProp.redfin_link ? thisProp.redfin_link : "None",
                    zillow_link: thisProp.zillow_link ? thisProp.zillow_link : "None",
                    realtor_link: thisProp.realtor_link ? thisProp.realtor_link : "None",
                    reference_point: thisProp.reference_point ? thisProp.reference_point : "None",
                    comp_score: thisProp.comp_score ? thisProp.comp_score.toFixed(2) : "None",
                    static_map: thisProp.static_map ? thisProp.static_map : "None",
                    left_affordablehousing_data: [thisProp.huduser_data ? thisProp.huduser_data["Two-Bedroom FMR Basis"] +
                        " " + thisProp.zip + " " + thisProp.beds + " bedrooms" : "?" + thisProp.zip + " " + thisProp.beds + " bedrooms",
                        "county", "city", "zip",
                    thisProp.affordablehousing_data ? thisProp.affordablehousing_data['mile radius'].radius + " mile radius" : "? mile radius"],

                    right_affordablehousig_data: [thisProp.affordablehousing_data ? "$ " + thisProp.affordablehousing_data["zip"].rent_estimate
                        : "None",
                    thisProp.affordablehousing_data ? "$ " + thisProp.affordablehousing_data.county.rent_estimate : "None",
                    thisProp.affordablehousing_data ? "$ " + thisProp.affordablehousing_data["city"].rent_estimate : "None",
                    thisProp.affordablehousing_data ? "$ " + thisProp.affordablehousing_data["zip"].rent_estimate : "None",
                    thisProp.affordablehousing_data ? "$ " + thisProp.affordablehousing_data['mile radius'].rent_estimate : "None"],

                    left_huduser_data: ["Efficiency", "One-Bedroom", "Two-Bedroom", "Three-Bedroom", "Four-Bedroom", "Two-Bedroom FMR Basis"],

                    right_huduser_data: [thisProp.huduser_data ? (thisProp.huduser_data["Efficiency"] ? thisProp.huduser_data["Efficiency"] : "None") : "None",
                    thisProp.huduser_data ? (thisProp.huduser_data["One-Bedroom"] ? thisProp.huduser_data["One-Bedroom"] : "None") : "None",
                    thisProp.huduser_data ? (thisProp.huduser_data["Two-Bedroom"] ? thisProp.huduser_data["Two-Bedroom"] : "None") : "None",
                    thisProp.huduser_data ? (thisProp.huduser_data["Three-Bedroom"] ? thisProp.huduser_data["Three-Bedroom"] : "None") : "None",
                    thisProp.huduser_data ? (thisProp.huduser_data["Four-Bedroom"] ? thisProp.huduser_data["Four-Bedroom"] : "None") : "None",
                    thisProp.huduser_data ? (thisProp.huduser_data["Two-Bedroom FMR Basis"] ? thisProp.huduser_data["Two-Bedroom FMR Basis"] : "None") : "None"]
                }
                duplicateExport.push(ExportSubjectdata)
                if (resp.data.comp_properties !== "null") {
                    compProp.map((item, i) => {
                        if (item.reference_point === true) {
                            // console.log("true")
                            this.state.referenceProps.push(item)
                            // console.log(this.state.referenceProps)
                        }
                        let data = { ...this.state.refinedData }

                        data["display_image_url"].push(item.display_image_url ? item.display_image_url : "None",)

                        data["beds"].push(item.beds ? item.beds : "None")
                        data["baths"].push(item.baths ? item.baths : "None")
                        data["square_feet"].push(item.square_feet ? item.square_feet : "None")
                        data["lot_square_feet"].push(item.lot_square_feet ? item.lot_square_feet : "None")
                        data["year_built"].push(item.year_built ? item.year_built : "None")
                        data["story"].push(item.story ? item.story : "None")
                        data["garage_type"].push(item.garage_type ? item.garage_type : "None")

                        data["distance_from_subject"].push(item?.travel_info ? (item.travel_info.distance_from_subject ? Number.parseFloat(item.travel_info.distance_from_subject).toFixed(2) + " Feet" : "None") : "None")

                        data["neighbourhood"].push(item.neighbourhood ? item.neighbourhood : "None")
                        data["subdivision"].push(item.subdivision ? item.subdivision : "None")
                        data["community"].push(item.community ? item.community : "None")
                        data["county"].push(item.county ? item.county : "None")

                        data["redfin"].push(item.redfin ? this.ExportNumberFormat(item.redfin) : "None")
                        data["zillow"].push(item.zillow ? this.ExportNumberFormat(item.zillow) : "None")
                        data["realtor"].push(item.realtor ? this.ExportNumberFormat(item.realtor) : "None")
                        data["price"].push(item.price ? this.ExportNumberFormat(item.price) : "None")

                        data["price_per_square_feet"].push(item.price_per_square_feet ? this.ExportNumberFormat(item.price_per_square_feet) : "None")
                        data["square_feet_difference"].push(item.square_feet_difference ? this.ExportNumberFormat(item.square_feet_difference) : "None")
                        data["adjusted_sales_price"].push(item.adjusted_sales_price ? this.ExportNumberFormat(item.adjusted_sales_price) : "None")

                        data["status"].push(item.listing_status ? (item.listing_status.charAt(0).toUpperCase() + item.listing_status.slice(1)).replaceAll('_', " ") : "None")
                        data["date_format"].push(item.date_format ? item : "None")
                        data["date_sold"].push(item.date_sold ? item.date_sold : "None")

                        data["median_price_neighborhood"].push(item.median_price?.neighborhood ? this.ExportNumberFormat(item.median_price?.neighborhood) : "None")
                        data["median_price_macro_neighborhood"].push(item.median_price?.macro_neighborhood ? this.ExportNumberFormat(item.median_price?.macro_neighborhood) : "None")
                        data["estimated_rent"].push(item.estimated_rent? this.ExportNumberFormat(item.estimated_rent) : "None")
                        data["redfin_link"].push(item.redfin_link ? item.redfin_link : "None")
                        data["zillow_link"].push(item.zillow_link ? item.zillow_link : "None")
                        data["realtor_link"].push(item.realtor_link ? item.realtor_link : "None")

                        data["latitude"].push(item.map_coordinates?.latitude ? item.map_coordinates?.latitude : "None")
                        data["longitude"].push(item.map_coordinates?.longitude ? item.map_coordinates?.longitude : "None")
                        data["address"].push(item.address ? item.address : "None")
                        data["reference_point"].push(item?.reference_point ? item?.reference_point?.toString() : "None")
                        data["comp_score"].push(item.comp_score ? item.comp_score.toFixed(2) : "None")
                        data["static_map"].push(item.static_map ? item.static_map : "")
                        data["zip"].push(item.zip ? item.zip : "None")
                        let dict = {
                            "images": item.carousel_images
                        }
                        this.state.compProperty.push(item.address ? item.address : "None");
                        this.state.comp_carousel_images.push(dict)
                        let Exportcompdata = {
                            display_image_url: item.display_image ? item.display_image : "None",
                            property: "COMP " + (i + 1),
                            address: item.address ? item.address : "None",
                            beds: item.beds ? item.beds : "None",
                            baths: item.baths ? item.baths : "None",
                            square_feet: item.square_feet ? item.square_feet : "None",
                            lot_square_feet: item.lot_square_feet ? item.lot_square_feet : "None",
                            year_built: item.year_built ? item.year_built : "None",
                            story: item.story ? item.story : "None",
                            garage_type: item.garage_type ? item.garage_type : "No Garage",
                            distance_from_subject: item?.travel_info ? (item.travel_info.distance_from_subject ? Number.parseFloat(item.travel_info.distance_from_subject).toFixed(2) + " Feet" : "None") : "None",
                            neighbourhood: item.neighbourhood ? item.neighbourhood : "None",
                            city: item.city ? item.city : "None",
                            county: item.county ? item.county : "None",
                            zillow: item.zillow ? this.ExportNumberFormat(item.zillow) : "None",
                            realtor: item.realtor ? this.ExportNumberFormat(item.realtor) : "None",
                            price: item.price ? this.ExportNumberFormat(item.price) : "None",
                            price_per_square_feet: item.price_per_square_feet ? this.ExportNumberFormat(item.price_per_square_feet) : "None",
                            estimated_rent: item.estimated_rent ? this.ExportNumberFormat(item.estimated_rent) : "None",
                            square_feet_difference: item.square_feet_difference ? this.ExportNumberFormat(item.square_feet_difference) : "None",
                            adjusted_sales_price: item.adjusted_sales_price ? this.ExportNumberFormat(item.adjusted_sales_price) : "None",
                            status: item.listing_status ? (item.listing_status.charAt(0).toUpperCase() + item.listing_status.slice(1)).replaceAll('_', " ") : "None",
                            date_sold: item.date_sold ? item.date_sold : "None",
                            median_price_neighborhood: item.median_price?.city ? this.ExportNumberFormat(item.median_price?.city) : "None",
                            redfin_link: item.redfin_link ? item.redfin_link : "None",
                            zillow_link: item.zillow_link ? item.zillow_link : "None",
                            realtor_link: item.realtor_link ? item.realtor_link : "None",
                            reference_point: item?.reference_point ? (item?.reference_point?.toString() === "true" ? item?.reference_point?.toString() + "(Referenced)" : item?.reference_point?.toString()) : "None",
                            comp_score: item.comp_score ? item.comp_score.toFixed(2) : "None",
                            static_map: item.s3_static_map ? item.s3_static_map : "None",
                            left_affordablehousing_data: [],
                            right_affordablehousig_data: [],
                            left_huduser_data: [],
                            right_huduser_data: []
                        }
                        this.setState({
                            refinedData: data,
                        })
                        duplicateExport.push(Exportcompdata)
                    })
                }
                setTimeout(async () => {
                    try {
                        let stateObj = { id: "100" };
                        await window.history.replaceState(stateObj,
                            "null", ((this.state.subjectRefinedData.address).replaceAll(" ", "-")).replaceAll(",", ""));

                        await axios.post(`${process.env.REACT_APP_BASE_URL}store_data`,
                            JSON.stringify(duplicateExport), headers
                        )
                            .then(async (res) => {
                                // await this.state.UUID.push(res.data);
                                await this.setState({
                                    UUID: res.data.ids
                                })
                            }).then(async () => {
                                this.setState({
                                    // isStored: true
                                });
                            });
                    } catch (e) {
                        toast.error("Failed to store the data");
                        this.setState({
                            REISearchloading: false,
                            loading: false,
                            showTbl: true,
                            text: ""
                        });
                    }
                }, 100);
                this.setState({
                    // isStored: true,
                    subjectRefinedData: subjectData,
                    isAddField: true,
                    text: "",
                    REISearchloading: false,
                    loading: false,
                    showTbl: true,
                    placeholder: "Manually Add a Comp"
                })
            }
        })
            .catch((error) => {
                toast.error("something went wrong!")
                this.setState({
                    REISearchloading: false,
                    loading: false,
                    text: "",
                    fieldCount: 0
                })
            })
    }
    async getCompPropertyData() {
        if (this.state.loading) {
            return
        }
        this.setState({ REISearchloading: true, loading: true })
        let len = this.state.compProperty.length
        const headers = {
            headers: {
                Authorization: "Bearer " + sessionStorage.getItem("token")
            }
        }
        await axios.post(`${process.env.REACT_APP_BASE_URL}comp_properties`, {
            "is_subject": false,
            "properties": [this.state.compProperty[len - 1]],
            "subject_property": {
                "square_feet": this.state.subjectRefinedData.square_feet,
                "map_coordinates": {
                    "address": this.state.subjectRefinedData.address,
                    "latitude": this.state.subjectRefinedData.latitude,
                    "longitude": this.state.subjectRefinedData.longitude
                }
            }
        }, headers)
            .then(async (resp) => {

                let data = { ...this.state.refinedData }
                let len = await Object.entries(resp.data.comp_properties).length
                let thisProp = await Object.entries(resp.data.comp_properties)[len - 1]
                let Exportdata = {
                    display_image_url: thisProp[1].display_image_url ? thisProp[1].display_image_url : "None",
                    property: "COMP " + len,
                    address: thisProp[1].address ? thisProp[1].address : "None",
                    beds: thisProp[1].beds ? thisProp[1].beds : "None",
                    baths: thisProp[1].baths ? thisProp[1].baths : "None",
                    square_feet: thisProp[1].square_feet ? thisProp[1].square_feet : "None",
                    lot_square_feet: thisProp[1].lot_square_feet ? thisProp[1].lot_square_feet : "None",
                    year_built: thisProp[1].year_built ? thisProp[1].year_built : "None",
                    story: thisProp[1].story ? thisProp[1].story : "None",
                    garage_type: thisProp[1].garage_type ? thisProp[1].garage_type : "No Garage",

                    distance_from_subject: thisProp[1].distance_from_subject ? thisProp[1].distance_from_subject : "None",

                    neighbourhood: thisProp[1].neighbourhood ? thisProp[1].neighbourhood : "None",
                    city: thisProp[1].city ? thisProp[1].city : "None",
                    county: thisProp[1].county ? thisProp[1].county : "None",

                    zillow: thisProp[1].zillow ? this.ExportNumberFormat(thisProp[1].zillow) : "None",
                    realtor: thisProp[1].realtor ? this.ExportNumberFormat(thisProp[1].realtor) : "None",
                    price: thisProp[1].price ? this.ExportNumberFormat(thisProp[1].price) : "None",

                    price_per_square_feet: thisProp[1].price_per_square_feet ? this.ExportNumberFormat(thisProp[1].price_per_square_feet) : "None",
                    estimated_rent: thisProp[1].estimated_rent ? this.ExportNumberFormat(thisProp[1].estimated_rent) : "None",
                    square_feet_difference: thisProp[1].square_feet_difference ? this.ExportNumberFormat(thisProp[1].square_feet_difference) : "None",
                    adjusted_sales_price: thisProp[1].adjusted_sales_price ? this.ExportNumberFormat(thisProp[1].adjusted_sales_price) : "None",
                    status: thisProp[1].listing_status ? (thisProp[1].listing_status.charAt(0).toUpperCase() + thisProp[1].listing_status.slice(1)).replaceAll('_', " ") : "None",
                    date_sold: thisProp[1].date_sold ? thisProp[1].date_sold : "None",

                    median_price_neighborhood: thisProp[1].median_price?.city ? this.ExportNumberFormat(thisProp[1].median_price?.city) : "None",

                    redfin_link: thisProp[1].redfin_link ? thisProp[1].redfin_link : "None",
                    zillow_link: thisProp[1].zillow_link ? thisProp[1].zillow_link : "None",
                    realtor_link: thisProp[1].realtor_link ? thisProp[1].realtor_link : "None",

                    static_map: thisProp[1].static_map ? thisProp[1].static_map : "None",
                    left_affordablehousing_data: [],
                    right_affordablehousig_data: [],
                    left_huduser_data: [],
                    right_huduser_data: []

                }
                if (Exportdata.address === "None") {
                    this.setState({
                        REISearchloading: false,
                        refinedData: data,
                        showTbl: true,
                        loading: false
                    })
                    toast.error("There is no data available on " + this.state.compProperty[len - 1])
                    this.handleStoreAPIError(this.state.text)
                } else {
                    data["display_image_url"].push(thisProp[1].display_image_url ? thisProp[1].display_image_url : "None",)

                    data["beds"].push(thisProp[1].beds ? thisProp[1].beds : "None")
                    data["baths"].push(thisProp[1].baths ? thisProp[1].baths : "None")
                    data["square_feet"].push(thisProp[1].square_feet ? thisProp[1].square_feet : "None")
                    data["lot_square_feet"].push(Exportdata.lot_square_feet)
                    data["year_built"].push(Exportdata.year_built)
                    data["story"].push(Exportdata.story)
                    data["garage_type"].push(Exportdata.garage_type)

                    data["distance_from_subject"].push(Exportdata.distance_from_subject)

                    data["neighbourhood"].push(Exportdata.neighbourhood)
                    data["subdivision"].push(thisProp[1].subdivision ? thisProp[1].subdivision : "None")
                    data["community"].push(thisProp[1].community ? thisProp[1].community : "None")
                    data["county"].push(Exportdata.county)

                    data["redfin"].push(Exportdata.redfin)
                    data["zillow"].push(Exportdata.zillow)
                    data["realtor"].push(Exportdata.realtor)
                    data["price"].push(Exportdata.price)

                    data["price_per_square_feet"].push(Exportdata.price_per_square_feet)
                    data["estimated_rent"].push(Exportdata.estimated_rent)
                    data["square_feet_difference"].push(Exportdata.square_feet_difference)
                    data["adjusted_sales_price"].push(Exportdata.adjusted_sales_price)

                    data["status"].push(Exportdata.status)
                    data["date_format"].push(thisProp[1].date_format ? thisProp[1] : "None")
                    data["date_sold"].push(Exportdata.date_sold)

                    data["median_price_neighborhood"].push(Exportdata.median_price_neighborhood)
                    data["median_price_macro_neighborhood"].push(thisProp[1].median_price?.zip ? this.ExportNumberFormat(thisProp[1].median_price?.zip) : "None")

                    data["redfin_link"].push(Exportdata.redfin_link)
                    data["zillow_link"].push(Exportdata.zillow_link)
                    data["realtor_link"].push(Exportdata.realtor_link)

                    data["latitude"].push(thisProp[1].map_coordinates?.latitude ? thisProp[1].map_coordinates?.latitude : "None")
                    data["longitude"].push(thisProp[1].map_coordinates?.longitude ? thisProp[1].map_coordinates?.longitude : "None")
                    data["address"].push(thisProp[1].map_coordinates?.address ? thisProp[1].map_coordinates?.address : "None")
                    data["static_map"].push(thisProp[1].static_map ? thisProp[1].static_map : "")
                    data["zip"].push(thisProp[1].zip)
                    await this.setState({
                        refinedData: data,
                        showTbl: true,
                        text: "",
                    })
                    setTimeout(async () => {
                        try {
                            await axios.post(`${process.env.REACT_APP_BASE_URL}store_data`,
                                JSON.stringify(Exportdata), headers
                            ).then(async (res) => {
                                this.setState({
                                    REISearchloading: false,
                                    loading: false
                                })
                                this.state.UUID.push(res.data)
                            }).then(() => console.log('uuid', this.state.UUID))
                        } catch (e) {
                            this.handleStoreAPIError(thisProp[1].address)
                            toast.error("Something went wrong!. Please try again!")
                            this.setState({
                                REISearchloading: false,
                                text: "",
                                loading: false,
                            })
                        }
                    }, 1000);
                }

            }).catch((e) => {
                alert(e)
                toast.error("something went wrong!. Please try again")
                this.setState({
                    REISearchloading: false,
                    text: "",
                    loading: false,
                })
            })
    }
    hoverHandler = (i) => {
        if (this.state.isBedHover === true) {
            this.setState({
                isBedHover: false,
                isLiCount: i
            })

        } else {
            this.setState({
                isBedHover: true,
                isLiCount: i
            })
        }

    }
    handleScroll = () => {
        this.setState({
            isBedHover: false,
            isLiCount: 0
        })
    }
    handleComProperty = async () => {
        var result = [...this.state.compProperty];
        if (this.state.text == "") {
            toast.error("address field is empty!")
            this.setState({
                loading: false
            })
            return
        } else {
            result.push((this.state.text).replace(/[\n\r\t\s]+/g, ' '))
            this.setState({ compProperty: result });
            setTimeout(() => {
                this.getCompPropertyData()
            }, 100);
        }

    }
    handleSubjectPropertyClose = async () => {
        this.navigation('/dashboard')
    }
    handleStoreAPIError = async (value) => {
        var rfArray = [...this.state.compProperty]
        var propIndex = rfArray.indexOf(value)
        if (propIndex > -1) {
            rfArray.splice(propIndex, 1,);
        }
        setTimeout(async () => {
            this.setState({
                compProperty: rfArray,
                loading: false,
                text: ""
            })
        }, 100)
    }
    handlePropertyClose = async (value, index) => {
        var rfArray = [...this.state.compProperty]
        var duplicateUUIDArray = [...this.state.UUID]
        var propIndex = rfArray.indexOf(value)
        rfArray.splice(propIndex, 1, "None");
        if (duplicateUUIDArray.length === 2) {
            duplicateUUIDArray.splice(index - 1, 1)
        } else {
            duplicateUUIDArray.splice(index, 1)
        }
        setTimeout(async () => {
            this.setState({
                compProperty: rfArray,
                UUID: duplicateUUIDArray,
                loading: false
            })
        }, 100)

    }
    NumberFormat = (input) => {
        const output = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        }).format(input);
        return <td>{output}</td>;
    }
    ExportNumberFormat = (input) => {
        if (input) {
            if (input[0] === "$") {
                return input
            } else {
                const output = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD',
                }).format(input);
                return output
            }

        } else {
            return "None"
        }

    }
    handleNoDataFound() {
        return toast("no data found")
    }
    exportReports = (fileType, endPoint) => {
        if (!this.state.UUID[0]) {
            toast.error('something went wrong!');
            return
        }
        else {
            if (this.state.loading) {
                toast.info("Please wait while loading is processing...")
                return
            }
            this.setState({ loading: true })
            const headers = {
                headers: {
                    Authorization: "Bearer " + sessionStorage.getItem("token")
                }
            }
            axios.post(`${process.env.REACT_APP_BASE_URL}${endPoint}`, {
                "id": this.state.UUID
            }, {
                responseType: 'blob',
                headers: {
                    Authorization: "Bearer " + sessionStorage.getItem("token")
                }
            }).then(async (response) => {
                this.setState({
                    loading: false
                })
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = url;
                link.setAttribute('download', `${this.state.subjectProperty}${fileType}`)
                document.body.appendChild(link)
                link.click()
                await axios.post(`${process.env.REACT_APP_BASE_URL}delete_local_sheet`, {
                    "name": this.state.subjectProperty
                }, headers).then((res) => {
                    // console.log(res.body)
                })
            }).catch((e) => {
                toast.error("Failed to download the file. Please try again")
                this.setState({
                    loading: false
                })
            })
        }

    }
    basicInfoHandler = () => {
        if (this.state.basicInfo === true) {
            this.setState({ basicInfo: false })
        } else {
            this.setState({ basicInfo: true })
        }
    }
    countySubdivisionsHandler = () => {
        if (this.state.county_subdivisions === true) {
            this.setState({ county_subdivisions: false })
        } else {
            this.setState({ county_subdivisions: true })
        }
    }
    pricesHandler = () => {
        if (this.state.prices === true) {
            this.setState({ prices: false })
        } else {
            this.setState({ prices: true })
        }
    }
    statusneighbourhoodHandler = () => {
        if (this.state.status_neighbourhood === true) {
            this.setState({ status_neighbourhood: false })
        } else {
            this.setState({ status_neighbourhood: true })
        }
    }
    linksHandler = () => {
        if (this.state.links === true) {
            this.setState({ links: false })
        } else {
            this.setState({ links: true })
        }
    }
    mapHandler = () => {
        if (this.state.isMap === true) {
            this.setState({ isMap: false })
        } else {
            this.setState({ isMap: true })
        }
    }
    autoCompHandler = () => {
        if (this.state.isAutoComp === true) {
            this.setState({ isAutoComp: false })
        } else {
            this.setState({ isAutoComp: true })
        }
    }
    referenceTabHandler = () => {
        if (this.state.isReferences === true) {
            this.setState({ isReferences: false })
        } else {
            this.setState({ isReferences: true })
        }
    }
    paramValues = {
        excel: 'make_excel',
        csv: 'make_csv',
        pdf: 'make_pdf',
        excelType: '.xlsx',
        csvType: '.csv',
        pdfType: '.pdf'
    }
    left_container_values = ["display image", "property type", "address", "Bed Count", "Bath Count", "Sq ft", "Lot Size", "Year Built",
        "Story", "Garage Type", "Distance", "sub divisions", "Community", "County", "Zillow", "Realtor", "Redfin", "Sale price", "last date sold ", "ppsf", "Est. Rent", "sqft difference", "Adjusted Sales Price", "status", "Median Price neighbourhood",
        "Median Price Macro neighbourhood", "Zillow Link", "Redfin Link", "Realtor Link", "Map"]
    properties_values = ["display_image_url", "beds", "baths", "square_feet", "lot_square_feet", "year_built",
        "story", "garage_type", "distance_from_subject", "subdivision", "neighbourhood", "county", "zillow", "realtor", "redfin",
        "price", "date_sold", "price_per_square_feet", "estimated_rent", "square_feet_difference", "adjusted_sales_price",
        "status", "median_price_neighborhood", "median_price_macro_neighborhood", "zillow_link", "redfin_link",
        "realtor_link", "reference_point", "comp_score", "static_map"
    ]
    data = {
        "Display Image": "https://images.pexels.com/photos/186077/pexels-photo-186077.jpeg",
        "property type": "subject property", "address": "3806 Lauderwood Ln Katy, TX 77449",
        "Bed Count": "4", "Bath Count": "4", "Sq Ft": "1000", "Lot Size": "1200", "Year Built": "1999",
        "Story": "4", "Garage Type": "2", "Distance": "1000", "Sub Division": "harries", "Neighbourhood": "neighbourhood",
        "County": "USA", "Zillow": "20155", "Realtor": "893658", "Redfin": "24325465", "Sale price": "556324",
        "Last Date Sold ": "26 march 2024", "PPSF": "50125", "Est. Rent": "242424", "SQFT Difference": "996633",
        "Adjusted Sales Price": "52424", "Status": "for sale", "Median Price neighbourhood": "8523641",
        "Median Price Macro neighbourhood": "521364", "Zillow Link": "https://www.redfin.com/TX/Katy/3639-Slocom-Dr-77449/home/30706435",
        "Redfin Link": "https://www.zillow.com/homes/3639-Slocom-Dr-Katy,-TX-77449_rb/55482725_zpid/", "Realtor Link": "https://www.zillow.com/homes/3639-Slocom-Dr-Katy,-TX-77449_rb/55482725_zpid/",
        "Reference Point": "reference_point", "Comp Score": "comp_score",
        "Map": "http"
    }
    tabInfo = {
        basicInfo: ["Bed Count", "Bath Count", "Sq Ft", "Lot Size", "Year Built",
            "Story", "Garage Type", "Distance"],
        subdivisionInfo: ["Sub Division", "Neighbourhood", "County"],
        priceInfo: ["Zillow", "Realtor", "Redfin", "Sale price",
            "Last Date Sold", "PPSF", "Est. Rent", "SQFT Difference", "Adjusted Sales Price"],
        statusInfo: ["Status", "Median Price neighbourhood", "Median Price Macro neighbourhood"],
        linksInfo: ["Zillow Link", "Redfin Link", "Realtor Link"],
        referenceInfo: ["Reference Point", "Comp Score"]
    }
    updateState = (stateName, value) => {
        this.setState({
            [stateName]: value
        })
    }
    callHandler = () => {
        if (this.state.fieldCount === 0) {
            this.getAutoComps(this.state.subjectProperty)
        } else {
            this.handleComProperty()
        }
    }
    handleSelect = (selectedIndex) => {
        this.setState({
            index: selectedIndex
        });
    };
    render() {
        const { isBedHover } = this.state;
        return (
            <>
                {/* <NewUI/> */}
                {this.state.showTbl ?
                    (<><Header state={this.state} updateState={this.updateState} callHandler={this.callHandler} paramValues={this.paramValues} exportReports={this.exportReports} />
                        <div>

                            <center><div className='load'>
                                {this.state.loading ? (<div className='loader'><div className="loading-spinner"></div></div>) : <></>}
                            </div></center>

                            <br></br>

                            {this.state.subjectProperty.address !== "None"
                                ?
                                (this.state.showTbl &&
                                    <><div className="main-div">
                                        <div className="right-container" id="scroll-bar">
                                            <div className={`left-container`}>
                                                <div className="left-data-container height180">
                                                    <div><iframe className='iframe-sec'
                                                        id="only" src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyDsUQIF718NhqIaUtjNqEiU1nypvW_Rbxo&q=${this.state.subjectProperty}&zoom=12`}
                                                        allowfullscreen=""
                                                        loading="lazy" referrerpolicy="no-referrer-when-downgrade">
                                                    </iframe></div>

                                                </div>
                                                <div className="left-data-container dummy">
                                                    {this.state.basicInfo === true ?
                                                        <><div className="tabDiv collapsed-Div" onClick={this.basicInfoHandler}><li className="allTabs">Basic Info</li>
                                                            <i class="fas fa-angle-down"></i></div></> :

                                                        <><div className="tabDiv openTab" onClick={this.basicInfoHandler}><li className="allTabs">Basic Info</li>
                                                            <i class="fas fa-angle-up"></i></div>
                                                            {Object.keys(this.data).map((item, i) => (
                                                                i < 3 ? "" :
                                                                    (i < 11 ? <>
                                                                        <li className={`li-item ${isBedHover === true && this.state.isLiCount === i ? "checkHover" : ""}`}
                                                                            onMouseOver={() => this.hoverHandler(i)}
                                                                            onMouseOut={() => this.hoverHandler(i)}

                                                                        >{item}</li>
                                                                    </> : "")
                                                            ))}</>}
                                                </div>
                                                <div className="left-data-container">
                                                    {this.state.county_subdivisions === true ? <><div className="tabDiv collapsed-Div" onClick={this.countySubdivisionsHandler}>
                                                        <li className="allTabs ">Sub Division</li><i class="fas fa-angle-down"></i></div></> :
                                                        <><div className="tabDiv openTab" onClick={this.countySubdivisionsHandler}><li className="allTabs">Sub Division</li>
                                                            <i class="fas fa-angle-up"></i></div>
                                                            {Object.keys(this.data).map((item, i) => (
                                                                (i < 14 && i > 10 ? <>
                                                                    <li className={`li-item ${isBedHover === true && this.state.isLiCount === i ? "checkHover" : ""}`}
                                                                        onMouseOver={() => this.hoverHandler(i)}
                                                                        onMouseOut={() => this.hoverHandler(i)}
                                                                    >{item}</li>
                                                                </> : "")
                                                            ))}</>}
                                                </div>
                                                <div className="left-data-container">
                                                    {this.state.prices === true ? <><div className="tabDiv collapsed-Div" onClick={this.pricesHandler}>
                                                        <li className="allTabs">Prices</li><i class="fas fa-angle-down"></i></div></> :
                                                        <><div className="tabDiv openTab" onClick={this.pricesHandler}><li className="allTabs">Prices</li>
                                                            <i class="fas fa-angle-up"></i></div>
                                                            {Object.keys(this.data).map((item, i) => (
                                                                (i < 22 && i > 13 ? <>
                                                                    <li className={`li-item ${isBedHover === true && this.state.isLiCount === i ? "checkHover" : ""}`}
                                                                        onMouseOver={() => this.hoverHandler(i)}
                                                                        onMouseOut={() => this.hoverHandler(i)}
                                                                    >{item}</li>
                                                                </> : "")
                                                            ))}</>}
                                                </div>
                                                <div className="left-data-container">
                                                    {this.state.status_neighbourhood === true ? <><div className="tabDiv collapsed-Div" onClick={this.statusneighbourhoodHandler}>
                                                        <li className="allTabs">Status/neighbourhood</li><i class="fas fa-angle-down"></i></div></> :
                                                        <><div className="tabDiv openTab" onClick={this.statusneighbourhoodHandler}><li className="allTabs">Status/neighbourhood</li>
                                                            <i class="fas fa-angle-up"></i></div>
                                                            {Object.keys(this.data).map((item, i) => (
                                                                (i < 26 && i > 22 ? <>
                                                                    <li className={`li-item ${isBedHover === true && this.state.isLiCount === i ? "checkHover" : ""}`}
                                                                        onMouseOver={() => this.hoverHandler(i)}
                                                                        onMouseOut={() => this.hoverHandler(i)}
                                                                    >{item}</li>
                                                                </> : "")
                                                            ))}</>}
                                                </div>
                                                <div className="left-data-container">
                                                    {this.state.links === true ? <><div className="tabDiv collapsed-Div" onClick={this.linksHandler}>
                                                        <li className="allTabs">Links</li><i class="fas fa-angle-down"></i></div></> :
                                                        <><div className="tabDiv openTab" onClick={this.linksHandler}>
                                                            <li className="allTabs">Links</li>
                                                            <i class="fas fa-angle-up"></i></div>
                                                            {Object.keys(this.data).map((item, i) => (
                                                                (i < 29 && i > 25 ? <>
                                                                    <li className={`li-item ${isBedHover === true && this.state.isLiCount === i ? "checkHover" : ""}`}
                                                                        onMouseEnter={() => this.hoverHandler(i)}
                                                                        onMouseLeave={() => this.hoverHandler(i)}
                                                                    >{item}</li>
                                                                </> : "")
                                                            ))}</>}
                                                </div>
                                                <div className="left-data-container">
                                                    {this.state.isReferences === true ? <><div className="tabDiv collapsed-Div" onClick={this.referenceTabHandler}>
                                                        <li className="allTabs">Reference</li><i class="fas fa-angle-down"></i></div></> :
                                                        <><div className="tabDiv openTab" onClick={this.referenceTabHandler}>
                                                            <li className="allTabs">Reference</li>
                                                            <i class="fas fa-angle-up"></i></div>
                                                            {Object.keys(this.data).map((item, i) => (
                                                                (i < 31 && i > 29 ? <>
                                                                    <li className={`li-item ${isBedHover === true && this.state.isLiCount === i ? "checkHover" : ""}`}
                                                                        onMouseEnter={() => this.hoverHandler(i)}
                                                                        onMouseLeave={() => this.hoverHandler(i)}
                                                                    >{item}</li>
                                                                </> : "")
                                                            ))}</>}
                                                </div>
                                                <div className="left-data-container " onClick={this.mapHandler}>
                                                    {this.state.isMap === true ? <><div className="tabDiv collapsed-Div">
                                                        <li className="allTabs ">Map</li><i class="fas fa-angle-down"></i></div></> :
                                                        <> <li className="tabDiv openTab">
                                                            <li className='allTabs'>Map</li><i class="fas fa-angle-up"></i></li>
                                                            <div className=" mapHeight"></div>
                                                        </>}
                                                </div>

                                            </div>
                                            <div className="right-data-container">
                                                <div className="header-sec">
                                                    {Object.keys(this.state.subjectRefinedData).map((item, i) => (
                                                        i < 3 ?
                                                            (i === 0 ?
                                                                <>
                                                                    <li className={`li-item-type-${i + 1}`}>SUBJECT PROPERTY
                                                                        <span className='close' onClick={() => this.handleSubjectPropertyClose()}><i class="fas fa-times"></i></span></li></>

                                                                :
                                                                (i === 1 ?
                                                                    (<CarouselComponent image={this.state.subject_carousel_images} />

                                                                    ) :
                                                                    (i === 2 ?
                                                                        <><OverlayTrigger overlay={
                                                                            <Tooltip >
                                                                                <strong>{this.state.subjectProperty?.toUpperCase()}</strong>.
                                                                            </Tooltip>
                                                                        }><li className={`li-item-type-${i} allTabs heading-ellipsis`}>
                                                                                <CopyToClipboard text={this.state.subjectProperty?.toUpperCase()}
                                                                                    onCopy={() => toast.success("address copied")}>
                                                                                    <span className="copyProperty">
                                                                                        <i class="fas fa-copy"></i></span>
                                                                                </CopyToClipboard>{this.state.subjectProperty?.toUpperCase()}</li>
                                                                        </OverlayTrigger>
                                                                        </> :
                                                                        "")
                                                                )) : ""
                                                    ))}
                                                </div>
                                                <div className='propertyBasicInfo'>
                                                    {this.state.basicInfo === true ? <div></div> :
                                                        Object.keys(this.state.subjectRefinedData).map((item, i) => (
                                                            i > 2 && i < 11 ?
                                                                <li className={`li-item-right ${isBedHover === true && this.state.isLiCount === i ? "checkHover" : ""}`}
                                                                    onMouseOver={() => this.hoverHandler(i)}
                                                                    onMouseOut={() => this.hoverHandler(i)}
                                                                >
                                                                    {this.state.subjectRefinedData[this.properties_values[i - 2]]}</li>
                                                                :
                                                                ""
                                                        ))}
                                                </div>
                                                <div className='propertyTabs'>
                                                    {this.state.county_subdivisions === true ? <div></div> :
                                                        Object.keys(this.state.subjectRefinedData).map((item, i) => (
                                                            i > 10 && i < 14 ?
                                                                (!this.state.subjectRefinedData[this.properties_values[i - 2]] ?
                                                                    <li className={`li-item-right ${isBedHover === true && this.state.isLiCount === i ? "checkHover" : ""}`}
                                                                        onMouseOver={() => this.hoverHandler(i)}
                                                                        onMouseOut={() => this.hoverHandler(i)}>None</li> :
                                                                    <li className={`li-item-right ${isBedHover === true && this.state.isLiCount === i ? "checkHover" : ""}`}
                                                                        onMouseOver={() => this.hoverHandler(i)}
                                                                        onMouseOut={() => this.hoverHandler(i)}>
                                                                        {this.state.subjectRefinedData[this.properties_values[i - 2]]}</li>)
                                                                :
                                                                ""
                                                        ))}
                                                </div>
                                                <div className='propertyTabs'>
                                                    {this.state.prices === true ? <div></div> :
                                                        Object.keys(this.state.subjectRefinedData).map((item, i) => (
                                                            i > 13 && i < 22 ?
                                                                <li className={`li-item-right ${isBedHover === true && this.state.isLiCount === i ? "checkHover" : ""}`}
                                                                    onMouseOver={() => this.hoverHandler(i)}
                                                                    onMouseOut={() => this.hoverHandler(i)}>
                                                                    {this.state.subjectRefinedData[this.properties_values[i - 2]]}</li>
                                                                :
                                                                ""
                                                        ))}
                                                </div>
                                                <div className='propertyTabs'>
                                                    {this.state.status_neighbourhood === true ? <div></div> :
                                                        Object.keys(this.state.subjectRefinedData).map((item, i) => (
                                                            i > 22 && i < 26 ?
                                                                <li className={`li-item-right ${isBedHover === true && this.state.isLiCount === i ? "checkHover" : ""}`}
                                                                    onMouseOver={() => this.hoverHandler(i)}
                                                                    onMouseOut={() => this.hoverHandler(i)}>
                                                                    {this.state.subjectRefinedData[this.properties_values[i - 2]]}</li>
                                                                :
                                                                ""
                                                        ))}
                                                </div>
                                                <div className='propertyTabs'>
                                                    {this.state.links === true ? <div></div> :
                                                        Object.keys(this.state.subjectRefinedData).map((item, i) => (
                                                            i > 25 && i < 29 ?
                                                                (this.state.subjectRefinedData[this.properties_values[i - 2]] === "None" ?
                                                                    <li className={`li-item-right ${isBedHover === true && this.state.isLiCount === i ? "checkHover" : ""}`}
                                                                        onMouseOver={() => this.hoverHandler(i)}
                                                                        onMouseOut={() => this.hoverHandler(i)}>None</li> :
                                                                    <li className={`li-item-right ${isBedHover === true && this.state.isLiCount === i ? "checkHover" : ""}`}
                                                                        onMouseOver={() => this.hoverHandler(i)}
                                                                        onMouseOut={() => this.hoverHandler(i)}>
                                                                        <CopyToClipboard text={this.state.subjectRefinedData[this.properties_values[i - 2]]}
                                                                            onCopy={() => toast.success("link copied")}>
                                                                            <span className="copy">
                                                                                <i class="fas fa-copy"></i></span>
                                                                        </CopyToClipboard>
                                                                        <a className="linkA" target="_blank" href={this.state.subjectRefinedData[this.properties_values[i - 2]]}>
                                                                            {/* {(this.state.subjectRefinedData[this.properties_values[i - 2]]).slice(0, (this.state.subjectRefinedData[this.properties_values[i - 2]]).indexOf('.com') + 4) + "/..."} */}
                                                                            {/* {this.properties_values[i - 2]} */}
                                                                            {(this.properties_values[i - 2].charAt(0).toUpperCase() + this.properties_values[i - 2].slice(1)).replaceAll("_link", " ")}
                                                                        </a>
                                                                    </li>)
                                                                :
                                                                ""
                                                        ))}
                                                </div>
                                                <div className='propertyTabs'>
                                                    {this.state.isReferences === true ? <div></div> :
                                                        Object.keys(this.state.subjectRefinedData).map((item, i) => (
                                                            i > 29 && i < 31 ?
                                                                <li className={`li-item-right ${isBedHover === true && this.state.isLiCount === i ? "checkHover" : ""}`}
                                                                    onMouseOver={() => this.hoverHandler(i)}
                                                                    onMouseOut={() => this.hoverHandler(i)}>Subject Property</li>
                                                                :
                                                                ""
                                                        ))}
                                                </div>
                                                <div className='maptab'>
                                                    {this.state.isMap === true ? "" :
                                                        <></>}
                                                </div>

                                            </div>
                                            {this.state.refinedData.address.map((value, index) => {
                                                return (
                                                    this.state.compProperty[index] === "None" ?
                                                        <></> :

                                                        this.state.refinedData["reference_point"][index] === "true" ?
                                                            <></> :
                                                            <>
                                                                <div className="right-data-container">
                                                                    <div className="header-sec">
                                                                        {Object.keys(this.state.refinedData).map((item, i) => (

                                                                            i < 3 ?
                                                                                (
                                                                                    i === 0 ?
                                                                                        (index === 0 ?
                                                                                            <>
                                                                                                <li className={`li-item-type-${i + 1}`}>
                                                                                                    <span class="badge badge-secondary badge"></span>COMP {index + 1}
                                                                                                    <span className="close" onClick={() => this.handlePropertyClose(this.state.refinedData.address[index], index + 1)}>
                                                                                                        <i class="fas fa-times"></i></span></li></> :
                                                                                            (this.state.refinedData.reference_point[index] === "true" ?
                                                                                                <><li className={`li-item-type-${i + 1}`}>
                                                                                                    {/* <span class="badge badge-secondary badge">Referenced</span> */}
                                                                                                    COMP {index + 1}
                                                                                                    <span className="close" onClick={() => this.handlePropertyClose(this.state.refinedData.address[index], index + 1)}>
                                                                                                        <i class="fas fa-times"></i></span></li></> :
                                                                                                (this.state.refinedData.reference_point[index - 1] == "false" && this.state.refinedData.reference_point[index + 1] === "true" && this.state.refinedData.reference_point[index] === "false" ?
                                                                                                    <><li className={`li-item-type-${i + 1}`}>
                                                                                                        <span class="badge badge-secondary badge">Lowest</span>
                                                                                                        COMP {index + 1}
                                                                                                        <span className="close" onClick={() => this.handlePropertyClose(this.state.refinedData.address[index], index + 1)}>
                                                                                                            <i class="fas fa-times"></i></span></li></> :
                                                                                                    <><li className={`li-item-type-${i + 1}`}>COMP {index + 1}
                                                                                                        <span className="close" onClick={() => this.handlePropertyClose(this.state.refinedData.address[index], index + 1)}>
                                                                                                            <i class="fas fa-times"></i></span></li></>))
                                                                                        )
                                                                                        :
                                                                                        (i === 1 ?
                                                                                            (<CarouselComponent image={this.state.comp_carousel_images[index]["images"]} />

                                                                                            ) :
                                                                                            (i === 2 ?
                                                                                                <>
                                                                                                    <OverlayTrigger overlay={
                                                                                                        <Tooltip >
                                                                                                            <strong>{this.state.refinedData.address[index].toUpperCase()}</strong>.
                                                                                                        </Tooltip>
                                                                                                    }><li className={`li-item-type-${i} allTabs heading-ellipsis`}>
                                                                                                            <CopyToClipboard text={this.state.refinedData.address[index].toUpperCase()}
                                                                                                                onCopy={() => toast.success("address copied")}>
                                                                                                                <span className="copyProperty">
                                                                                                                    <i class="fas fa-copy"></i></span>
                                                                                                            </CopyToClipboard>
                                                                                                            {this.state.refinedData.address[index].toUpperCase()}</li>
                                                                                                    </OverlayTrigger>

                                                                                                </> :
                                                                                                (this.properties_values[i - 2] === 'static_map' ?
                                                                                                    <img className="comPropMap" src={`data:image/jpeg;base64,${this.state.refinedData[this.properties_values[i - 2]][index]}`} />
                                                                                                    :
                                                                                                    (!this.state.refinedData[this.properties_values[i - 2]][index] ||
                                                                                                        this.state.refinedData[this.properties_values[i - 2]][index] === "None" ||
                                                                                                        this.state.refinedData[this.properties_values[i - 2]][index] === "?" ?
                                                                                                        <li className="li-item-right">None</li> :
                                                                                                        (this.properties_values[i - 2] === "redfin_link" ||
                                                                                                            this.properties_values[i - 2] === "zillow_link" ||
                                                                                                            this.properties_values[i - 2] === "realtor_link" ?
                                                                                                            (this.state.refinedData[this.properties_values[i - 2]][index] === "None" ? <></> :
                                                                                                                <li className="li-item-right">
                                                                                                                    <CopyToClipboard text={this.state.refinedData[this.properties_values[i - 2]][index]}
                                                                                                                        onCopy={() => toast.success("link copied")}>
                                                                                                                        <span className="copy">
                                                                                                                            <i class="fas fa-copy"></i></span>
                                                                                                                    </CopyToClipboard>
                                                                                                                    <a target="_blank" href={this.state.refinedData[this.properties_values[i - 2]][index]}>
                                                                                                                        {/* {(this.state.refinedData[this.properties_values[i - 2]][index]).slice(0, (this.state.refinedData[this.properties_values[i - 2]][index]).indexOf('.com') + 4) + "/..."} */}
                                                                                                                        {(this.properties_values[i - 2].charAt(0).toUpperCase() + this.properties_values[i - 2].slice(1)).replaceAll("_link", " ")}
                                                                                                                    </a>

                                                                                                                </li>)
                                                                                                            :
                                                                                                            <li className="li-item-right">{this.state.refinedData[this.properties_values[i - 2]][index]}</li>
                                                                                                        )
                                                                                                    )
                                                                                                ))
                                                                                        )) : ""
                                                                        )
                                                                        )}
                                                                    </div>
                                                                    <div className='propertyBasicInfo'>
                                                                        {this.state.basicInfo === true ? <div></div> :
                                                                            Object.keys(this.state.refinedData).map((item, i) => (
                                                                                i > 2 && i < 11 ?
                                                                                    <li className={`li-item-right ${isBedHover === true && this.state.isLiCount === i ? "checkHover" : ""}`}
                                                                                        onMouseOver={() => this.hoverHandler(i)}
                                                                                        onMouseOut={() => this.hoverHandler(i)}
                                                                                    >{this.state.refinedData[this.properties_values[i - 2]][index]}</li>
                                                                                    :
                                                                                    ""
                                                                            ))}
                                                                    </div>
                                                                    <div className='propertyTabs'>
                                                                        {this.state.county_subdivisions === true ? <div></div> :
                                                                            Object.keys(this.state.refinedData).map((item, i) => (
                                                                                i > 10 && i < 14 ?
                                                                                    (!this.state.refinedData[this.properties_values[i - 2]][index] ?
                                                                                        <li className={`li-item-right ${isBedHover === true && this.state.isLiCount === i ? "checkHover" : ""}`}
                                                                                            onMouseOver={() => this.hoverHandler(i)}
                                                                                            onMouseOut={() => this.hoverHandler(i)}>
                                                                                            None</li> :
                                                                                        <li className={`li-item-right ${isBedHover === true && this.state.isLiCount === i ? "checkHover" : ""}`}
                                                                                            onMouseOver={() => this.hoverHandler(i)}
                                                                                            onMouseOut={() => this.hoverHandler(i)}>{this.state.refinedData[this.properties_values[i - 2]][index]}</li>)
                                                                                    :
                                                                                    ""
                                                                            ))}
                                                                    </div>
                                                                    <div className='propertyTabs'>
                                                                        {this.state.prices === true ? <div></div> :
                                                                            Object.keys(this.state.refinedData).map((item, i) => (
                                                                                i > 13 && i < 22 ?
                                                                                    (this.state.refinedData[this.properties_values[i - 2]][index] === "None" ||
                                                                                        !this.state.refinedData[this.properties_values[i - 2]][index] ?
                                                                                        <li className={`li-item-right ${isBedHover === true && this.state.isLiCount === i ? "checkHover" : ""}`}
                                                                                            onMouseOver={() => this.hoverHandler(i)}
                                                                                            onMouseOut={() => this.hoverHandler(i)}>None</li> :
                                                                                        <li className={`li-item-right ${isBedHover === true && this.state.isLiCount === i ? "checkHover" : ""}`}
                                                                                            onMouseOver={() => this.hoverHandler(i)}
                                                                                            onMouseOut={() => this.hoverHandler(i)}>{this.state.refinedData[this.properties_values[i - 2]][index]}</li>)
                                                                                    :
                                                                                    ""
                                                                            ))}
                                                                    </div>
                                                                    <div className='propertyTabs'>
                                                                        {this.state.status_neighbourhood === true ? <div></div> :
                                                                            Object.keys(this.state.refinedData).map((item, i) => (
                                                                                i > 22 && i < 26 ?
                                                                                    <li className={`li-item-right ${isBedHover === true && this.state.isLiCount === i ? "checkHover" : ""}`}
                                                                                        onMouseOver={() => this.hoverHandler(i)}
                                                                                        onMouseOut={() => this.hoverHandler(i)}>{this.state.refinedData[this.properties_values[i - 2]][index]}</li>
                                                                                    :
                                                                                    ""
                                                                            ))}
                                                                    </div>
                                                                    <div className='propertyTabs'>
                                                                        {this.state.links === true ? <div></div> :
                                                                            Object.keys(this.state.refinedData).map((item, i) => (
                                                                                i > 25 && i < 29 ?
                                                                                    (this.state.refinedData[this.properties_values[i - 2]][index] === "None" ?
                                                                                        <li className={`li-item-right ${isBedHover === true && this.state.isLiCount === i ? "checkHover" : ""}`}
                                                                                            onMouseOver={() => this.hoverHandler(i)}
                                                                                            onMouseOut={() => this.hoverHandler(i)}>None</li> :
                                                                                        <li className={`li-item-right ${isBedHover === true && this.state.isLiCount === i ? "checkHover" : ""}`}
                                                                                            onMouseOver={() => this.hoverHandler(i)}
                                                                                            onMouseOut={() => this.hoverHandler(i)}>
                                                                                            <CopyToClipboard text={this.state.refinedData[this.properties_values[i - 2]][index]}
                                                                                                onCopy={() => toast.success("link copied")}>
                                                                                                <span className="copy">
                                                                                                    <i class="fas fa-copy"></i></span>
                                                                                            </CopyToClipboard>
                                                                                            <a className="linkA" target="_blank" href={this.state.refinedData[this.properties_values[i - 2]][index]}>
                                                                                            {(this.properties_values[i - 2].charAt(0).toUpperCase() + this.properties_values[i - 2].slice(1)).replaceAll("_link", " ")}
                                                                                                {/* {(this.state.refinedData[this.properties_values[i - 2]][index]).slice(0,
                                                                                                    (this.state.refinedData[this.properties_values[i - 2]][index]).indexOf('.com') + 4) + "/..."} */}
                                                                                            </a>
                                                                                        </li>)
                                                                                    :
                                                                                    ""
                                                                            ))}
                                                                    </div>
                                                                    <div className='propertyTabs'>
                                                                        {this.state.isReferences === true ? <div></div> :
                                                                            Object.keys(this.state.refinedData).map((item, i) => (
                                                                                i > 29 && i < 31 ?
                                                                                    <li className={`li-item-right ${isBedHover === true && this.state.isLiCount === i ? "checkHover" : ""}`}
                                                                                        onMouseOver={() => this.hoverHandler(i)}
                                                                                        onMouseOut={() => this.hoverHandler(i)}>{this.state.refinedData[this.properties_values[i - 2]][index]}</li>
                                                                                    :
                                                                                    ""
                                                                            ))}
                                                                    </div>
                                                                    <div className='maptab'>

                                                                        {this.state.isMap === true ? "" :
                                                                            (this.state.refinedData.static_map[index] === "None" || this.state.refinedData.static_map[index] === "" ?

                                                                                <img className="property" src={"data:image/png;base64,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"} />
                                                                                :
                                                                                (
                                                                                    this.state.refinedData.static_map[index].slice(0, this.state.refinedData.static_map[index].indexOf('//') + 2) === "https://" ?
                                                                                        <img className="property" src={this.state.refinedData.static_map[index]} /> :
                                                                                        <img className="property" src={`data:image/png;base64,${this.state.refinedData.static_map[index]}`} />)
                                                                            )}
                                                                    </div>
                                                                </div></>

                                                );
                                            })}
                                        </div>

                                    </div>

                                        <Affordable_Hub huduser_data={this.state.huduser_data} affordablehousing_data={this.state.affordablehousing_data} subjectRefinedData={this.state.subjectRefinedData} />
                                        {this.state.isStored ?
                                            <><Reference_Properties referenceProps={this.state.referenceProps} />
                                                <Rental_Comps property={this.state.subjectRefinedData.address} />
                                                <Affordable_housing address={this.state.subjectRefinedData.address} latitude={this.state.subjectRefinedData.latitude}
                                                    longitude={this.state.subjectRefinedData.longitude}
                                                    city={this.state.city} state={this.state.state} zip={this.state.zip} />
                                                <NewPadSplit address={this.state.subjectRefinedData.address} latitude={this.state.subjectRefinedData.latitude}
                                                    longitude={this.state.subjectRefinedData.longitude}
                                                    city={this.state.city} state={this.state.state} zip={this.state.zip} /></> : <></>}
                                    </>
                                ) : <></>}

                            <ToastContainer />
                        </div></>) : <>
                        {this.state.fieldCount > 0 ?
                            <Page /> : <></>}
                        <center><div>
                            {this.state.loading ? (<div className='loader'><div className="loading-spinner"></div></div>) : <></>}
                        </div></center>
                        <ToastContainer />
                    </>}


            </>
        )
    }
}

export default Home;
